
import { emit } from '@nextcloud/event-bus'
import { t } from '@nextcloud/l10n'
import NcActionButton from '@nextcloud/vue/components/NcActionButton'
import NcActionButtonGroup from '@nextcloud/vue/components/NcActionButtonGroup'
import NcActions from '@nextcloud/vue/components/NcActions'
import IconEmoticonOutline from 'vue-material-design-icons/EmoticonOutline.vue'

export default {
	name: 'ReactionMenu',

	components: {
		NcActions,
		NcActionButton,
		NcActionButtonGroup,
		IconEmoticonOutline,
	},

	props: {
		/**
		 * The conversation token
		 */
		token: {
			type: String,
			required: true,
		},

		/**
		 * Signalling participant model
		 */
		localCallParticipantModel: {
			type: Object,
			required: true,
		},

		/**
		 * Supported reactions
		 */
		supportedReactions: {
			type: Array,
			validator: (prop) => prop.every((e) => typeof e === 'string'),
			required: true,
		},
	},

	data() {
		return {
			throttleTimer: null,
		}
	},

	computed: {
		reactionsInSingleRow() {
			return Math.ceil(this.supportedReactions.length / 2)
		},
	},

	methods: {
		t,
		throttledSendReaction(reaction) {
			if (this.throttleTimer) {
				return
			}

			this.sendReaction(reaction)
			this.throttleTimer = setTimeout(() => {
				this.throttleTimer = null
			}, 2000)
		},

		sendReaction(reaction) {
			// send reaction to other participants
			this.localCallParticipantModel.sendReaction(reaction)

			// show reaction to yourself
			emit('send-reaction', {
				model: this.localCallParticipantModel,
				reaction,
			})
		},
	},
}
